<template>
  <AppStack
    align-items="items-center"
    justify-content="justify-center"
    wrap="flex-wrap"
    class="gap-3 w-[272px]"
  >
    <AppStack
      v-for="key in 9"
      :key="key"
      :class="props.loading ? ['opacity-50 pointer-events-none'] : []"
      tag="button"
      align-items="items-center"
      justify-content="justify-center"
      class="w-[76px] h-[76px] relative bg-bg-elevation-2 rounded-2xl active:opacity-70
        transition-opacity active:top-[1px] shadow-elevation-2-0-xs"
      @click="onKeyClick(key)"
    >
      <AppTypography
        :text="String(key)"
        color="text-fg-elevation-2-primary"
        type="heading-2xl-8-medium"
      />
    </AppStack>
    <AppStack
      align-items="items-center"
      justify-content="justify-center"
      tabindex="-1"
      class="w-[76px] h-[76px] relative"
    />
    <AppStack
      :class="props.loading ? ['opacity-50 pointer-events-none'] : []"
      tag="button"
      align-items="items-center"
      justify-content="justify-center"
      class="w-[76px] h-[76px] relative bg-bg-elevation-2 rounded-2xl active:opacity-70
        transition-opacity active:top-[1px]"
      @click="onKeyClick(0)"
    >
      <AppTypography
        text="0"
        color="text-fg-elevation-2-primary"
        type="heading-2xl-7-medium"
      />
    </AppStack>
    <AppStack
      :class="props.loading ? ['opacity-50 pointer-events-none'] : []"
      tag="button"
      align-items="items-center"
      justify-content="justify-center"
      class="w-[76px] h-[76px] relative border-border-elevation-2-secondary border-[2px]
        border-solid rounded-2xl active:opacity-70 transition-opacity active:top-[1px]"
      @click="onKeyClick('delete')"
    >
      <BackspaceIcon
        class="text-fg-elevation-2-tertiary relative -left-[2px] w-[28px] h-[28px]"
      />
    </AppStack>
  </AppStack>
</template>

<script setup lang="ts">
import { Capacitor } from '@capacitor/core'
import { Haptics, ImpactStyle } from '@capacitor/haptics'
import { BackspaceIcon } from '@heroicons/vue/24/outline'

import AppStack from '@restify/packages/design-system/low-level/AppStack.vue'
import AppTypography from '@restify/packages/design-system/low-level/AppTypography.vue'

const emit = defineEmits<{
  'key': [key: number]
  'delete': [void]
}>()

const props = defineProps<{
  loading?: boolean
}>()

const onKeyClick = (key: 'delete' | number) => {
  if (Capacitor.isNativePlatform()) {
    Haptics.impact({ style: ImpactStyle.Medium })
  }

  if (key === 'delete') {
    emit('delete')
  } else {
    emit('key', key)
  }
}
</script>
